div.challenge-image {
  display: flex;
  justify-content: center;
}

img.challenge-image-rs {
  width: 100%;
  max-width: 256px;
}

@media (min-width: 576px) {
  div.challenge-image {
    width: 227px;
  }
  img.challenge-image-rs {
    margin: -6%;
    width: auto;
  }
}

video {
  width: 100%;
}

.white-background {
  width: 100%;
  padding: 36px 0;
  background-color: white;
  border-radius: 8px;
}

@media (min-width: 576px) {
  .white-background {
    width: auto;
    padding: 43px;
  }
}

.block {
  display: block;
}

@media (min-width: 576px) {
  img.expired {
    cursor: pointer;
  }
}

.cursor-pointer {
  cursor: pointer;
}
